/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  DeleteApiV1SerievideoId202,
  DeleteApiV1SerievideoId401,
  DeleteApiV1SerievideoId404,
  DeleteApiV1SerievideoId500,
  DeleteApiV1SerievideoIdMutationResponse,
  DeleteApiV1SerievideoIdPathParams,
  DeleteApiV1SerievideoIdQueryParams,
} from "../../types/serieVideoRegistroController/DeleteApiV1SerievideoId.ts";

export const deleteApiV1SerievideoIdPathParamsSchema = z.object({
  id: z.coerce.number().int(),
}) as unknown as ToZod<DeleteApiV1SerievideoIdPathParams>;

export const deleteApiV1SerievideoIdQueryParamsSchema = z
  .object({
    serieId: z.optional(z.coerce.number().int()),
  })
  .optional() as unknown as ToZod<DeleteApiV1SerievideoIdQueryParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const deleteApiV1SerievideoId202Schema =
  z.any() as unknown as ToZod<DeleteApiV1SerievideoId202>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const deleteApiV1SerievideoId401Schema =
  z.any() as unknown as ToZod<DeleteApiV1SerievideoId401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const deleteApiV1SerievideoId404Schema =
  z.any() as unknown as ToZod<DeleteApiV1SerievideoId404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const deleteApiV1SerievideoId500Schema =
  z.any() as unknown as ToZod<DeleteApiV1SerievideoId500>;

export const deleteApiV1SerievideoIdMutationResponseSchema = z.lazy(
  () => deleteApiV1SerievideoId202Schema,
) as unknown as ToZod<DeleteApiV1SerievideoIdMutationResponse>;
